var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-listing"},[(_vm.editImage)?_c('ImageEdit',{attrs:{"image":_vm.image}}):_c('ImageView',{attrs:{"image":_vm.listing,"editable":_vm.editable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }